import RootLayout from "@/app/layout";
import data from '../../data/angebot/data.json';
import { DetailAngebotSection } from "@/app/components/Sections/DetailAngebotSection";
import Head from "next/head";

export const metadata = {
    title: 'Hebamme Lea Stiffler | Wochenbettbetreuung',
    description: 'Biete umfassende Wochenbettbetreuung, Schweiz, an. Erfahre professionelle Unterstützung nach der Geburt, inklusive Stillberatung, Säuglingspflege und mehr. Alles für einen optimalen Start in das neue Familienleben.',
    keywords: 'Wochenbettbetreuung, Stillberatung, Säuglingspflege, Chur, professionelle Hebamme, Unterstützung nach der Geburt, Familienleben',
    canonicalUrl: 'https://hebamme-leastiffler.ch/wochenbettbetreuung'
}


export async function getStaticProps() {
    return { props: { data } }
}

export default function Wochenbettbetreuung({ data }) {
    const wochenbettbetreuungData = data.WochenbettBetreuung;

    return (
        <RootLayout>
            <Head>
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <link rel="canonical" href={metadata.canonicalUrl} />
            </Head>
            <DetailAngebotSection data={wochenbettbetreuungData} />
        </RootLayout>
    )
}